import React from 'react'

import { ObserverProvider } from '~contexts/ObserverContext'

const Observer = ({
  children
}) => (
  <ObserverProvider>
    { children }
  </ObserverProvider>
)

export default Observer